import React, { type ButtonHTMLAttributes, forwardRef, type MouseEvent, type ReactNode } from 'react';

import { type TooltipVariant } from '@pkg/components';
import { usePopoverContext } from '@pkg/components/Elements/Tooltip/hooks';
import { PopoverAction } from '@pkg/components/Elements/Tooltip/styles';

type ActionProps = ButtonHTMLAttributes<HTMLButtonElement> & {
    handleClick?: (e?: MouseEvent<HTMLButtonElement>) => void;
    variant?: TooltipVariant;
    children: ReactNode;
};
export const PopoverClose = forwardRef<HTMLButtonElement, ActionProps>(function PopoverClose(props, ref) {
    const { setOpen } = usePopoverContext();
    return (
        <PopoverAction
            $variant={props.variant}
            ref={ref}
            {...props}
            onClick={() => {
                props.handleClick?.();
                setOpen(false);
            }}
        >
            {props.children}
        </PopoverAction>
    );
});
